import axios, { AxiosRequestConfig } from "axios";
import RequestAPI from "..";
import { generateMessageReturn } from "../../utils/messageFuncs";

class ApiUsers extends RequestAPI {
  config: AxiosRequestConfig;
  data?: any;
  basePath = "user";
  constructor(data?: any) {
    super();
    this.config = {
      maxBodyLength: Infinity,
      headers: {
        "Content-Type": "application/json",
      },
    };
    if (data) {
      this.data = data;
      this.config.data = data;
    }
  }

  create = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/create`;
    this.config.method = "post";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Criação de Usuário",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });
    return this.result;
  };

  confirm = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/confirm/${this.data.id}/${this.data.codigo}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Confirmação de Usuário",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });

    return this.result;
  };

  resetCode = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/reset-code/${this.data.email}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Código de Confirmação",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });

    return this.result;
  };

  resendPassword = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/resend-password/${this.data.email}`;
    this.config.method = "get";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Recuperaação de senha",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });

    return this.result;
  };

  resetPassword = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/reset-password`;
    this.config.method = "post";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn(
              "Erro: Recuperaação de senha",
              error.message,
              "danger"
            ),
          ];
          return this.result;
        }
      });

    return this.result;
  };

  login = async () => {
    this.config.url = `${this.baseUrl}/${this.basePath}/login`;
    this.config.method = "post";

    this.result = await axios(this.config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        try {
          return error.response.data;
        } catch (errorCatch) {
          this.result.message = [
            generateMessageReturn("Erro: Login", error.message, "danger"),
          ];
          return this.result;
        }
      });

    return this.result;
  };
}

export default ApiUsers;
